import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { DateTime } from 'luxon';

import Table from '../../../components/Table/Table';
import TableHead from '../../../components/Table/TableHead';
import TableRow from '../../../components/Table/TableRow';
import TableHeadData from '../../../components/Table/TableHeadData';
import TableBody from '../../../components/Table/TableBody';
import TableData from '../../../components/Table/TableData';
import PermissionsGate from '../../../components/PermissionsGate/PermissionsGate';
import AccessDenied from '../../../components/AccessDenied/AccessDenied';
import { permissions } from '../../../common/permissionGroup';
import Layout from '../../../layout/Layout';
import Card from '../../../components/Card/Card';
import EmptyTable from '../../../components/Table/EmptyTable';
import getJobsFailed from '../../../thunks/jobs/getJobsFailed';
import ButtonTypes from '../../../constants/buttonTypes';
import Badge from '../../../components/Badge/Badge';
import Pagination from '../../../components/Pagination/Pagination';
import { IconCode } from '../../../assets/icon';
import Button from '../../../components/Button/Button';
import Modal from '../../../components/Modal/Modal';

const logButtonClassName = 'h-[32px] w-[32px] p-0';
const logIconClassName = 'h-[18px] w-[18px] text-info';

function JobsFailed() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [logsData, setLogsData] = useState();

  const {
    getJobsFailed: {
      loading: getJobsFailedLoading,
      data: getJobsFailedData = [],
      current_page: currentPage,
      last_page: lastPage
    },
  } = useSelector((state) => ({
    getJobsFailed: state.getJobsFailed
  }));

  const breadcrumbs = {
    pageTitle: 'Jobs',
    history: [
      {
        title: 'Home',
        onClick: () => navigate('/')
      },
      {
        title: 'Job Failed',
      },
    ]
  };

  const onPagePress = (page) => {
    dispatch(getJobsFailed({
        page
    }));
  };

  useEffect(() => {
    dispatch(getJobsFailed());
  }, []);

  return (
    <Layout breadcrumbs={breadcrumbs} pageTitle="Job Failed">
      <PermissionsGate
        can={permissions.JOBS_READ}
        errorComponent={<AccessDenied />}
      >
        <Card
          showHeader={false}
          headerBordered={false}
          footer={(
            <div className="d-flex d-justify-end">
              <Pagination
                currentPage={currentPage}
                onPagePress={onPagePress}
                lastPage={lastPage}
              />
            </div>
          )}
          footerBordered={false}
        >
          <div>
            <Table loading={getJobsFailedLoading}>
              <TableHead>
                <TableRow bordered>
                  <TableHeadData>
                    Id
                  </TableHeadData>
                  <TableHeadData>
                    Created At
                  </TableHeadData>
                  <TableHeadData>
                    Queue
                  </TableHeadData>
                  <TableHeadData>
                    Payload
                  </TableHeadData>
                  <TableHeadData>
                    Attempts
                  </TableHeadData>
                  <TableHeadData>
                    Available At
                  </TableHeadData>
                  <TableHeadData>
                    Reserved At
                  </TableHeadData>
                </TableRow>
              </TableHead>
              <TableBody>
                {getJobsFailedData?.length
                  ? getJobsFailedData.map((job) => {
                    const {
                      id,
                      queue,
                      created_at: createdAt,
                      payload: jobData,
                      attempts,
                      available_at: availableAt,
                      reserved_at: reservedAt
                    } = job || {};
                    return (
                      <TableRow>
                        <TableData>
                          {id}
                        </TableData>
                        <TableData>
                          <Badge
                            type={ButtonTypes.LIGHT}
                            text={DateTime.fromISO(createdAt, { zone: 'utc' })
                              .setLocale() // або інша мова
                              .toRelative()}
                          />
                        </TableData>
                        <TableData>
                          <Badge
                            type={ButtonTypes.LIGHT}
                            text={queue}
                          />
                        </TableData>
                        <TableData>
                          <Button
                            containerStyle={logButtonClassName}
                            type={ButtonTypes.LIGHT}
                            icon={<IconCode className={logIconClassName} />}
                            onClick={() => setLogsData(jobData)}
                          />
                        </TableData>
                        <TableData>
                          {attempts}
                        </TableData>
                        <TableData>
                          <Badge
                            type={ButtonTypes.LIGHT}
                            text={DateTime.fromSeconds(availableAt, { zone: 'utc' })
                              .setLocale() // або інша мова
                              .toRelative()}
                          />
                        </TableData>
                        <TableData>
                          {reservedAt ? (
                            <Badge
                              type={ButtonTypes.LIGHT}
                              text={DateTime.fromSeconds(reservedAt, { zone: 'utc' })
                                .setLocale() // або інша мова
                                .toRelative()}
                            />
                          ) : '---'}
                        </TableData>
                        <TableData />
                      </TableRow>
                    );
                  })
                  : (<EmptyTable colSpan={7} text="No any data find" />)}
              </TableBody>
            </Table>
          </div>
        </Card>
        <Modal visible={!!logsData} toggleVisible={() => setLogsData(false)} hideSaveBtn>
          <div style={{ overflow: 'auto' }}>
            <pre>
              {logsData && JSON.stringify(JSON.parse(logsData), null, 2)}
            </pre>
          </div>
        </Modal>
      </PermissionsGate>
    </Layout>
  );
}

export default JobsFailed;
